export const languages = [
  { code: "zh", label: "简体中文", short: "中文", dir: "ltr" },
  { code: "en", label: "English", short: "EN", dir: "ltr" },
];

export const CONTENT_VERSION = 18;

const common = {
  sectionOrder: ["hero", "snapshot", "lineCard", "trinityModel", "solutions", "capabilities", "proof", "phison", "milestones", "revenue", "global", "team", "partnership"],
  hiddenSections: [],
  heroPanels: [
    {
      image:
        "https://static.prod-images.emergentagent.com/jobs/528e2918-c2db-41ac-a628-3dc420ec41f2/images/b31f1f9fe84e9bb012e186fa995a3091f8e7041f67a1a2d37a0f83e34c060eef.png",
    },
    {
      image:
        "https://static.prod-images.emergentagent.com/jobs/528e2918-c2db-41ac-a628-3dc420ec41f2/images/5addf713c32d02370ac89a1a0ff6954e804d49057e31f51aea0231a9c383d52f.png",
    },
    {
      image:
        "https://static.prod-images.emergentagent.com/jobs/528e2918-c2db-41ac-a628-3dc420ec41f2/images/08d658bb5fe75748a9a075bee8b6c6b61f1eeecd0c628f4ab147b8f78a2488ba.png",
    },
  ],
  proofImages: [{ image: "" }, { image: "" }, { image: "" }, { image: "" }, { image: "" }],
  snapshotImages: [{ image: "" }, { image: "" }],
  lineCardImages: [{ image: "" }, { image: "" }],
  milestoneImages: [{ image: "" }, { image: "" }],
  phisonImages: [{ image: "" }, { image: "" }],
  capabilityImages: [{ image: "" }, { image: "" }],
  globalImages: [{ image: "" }, { image: "" }],
  partnershipImages: [{ image: "" }],
  teamImages: [{ image: "" }, { image: "" }, { image: "" }, { image: "" }],
  partnerLogos: [
    "https://customer-assets.emergentagent.com/job_a89e862a-98ad-4f38-977b-c9e55f25da2b/artifacts/7hv74d2c_image.png",
    "",
    "",
    "",
    "",
  ],
  solutionImages: ["", "", ""],
  brandLogo: "https://customer-assets.emergentagent.com/job_a89e862a-98ad-4f38-977b-c9e55f25da2b/artifacts/ly79isjq_image.png",
  mapRegions: [
    { key: "united-kingdom", coordinates: [-3.4, 55.4], group: "Europe" },
    { key: "italy", coordinates: [12.6, 42.8], group: "Europe" },
    { key: "sweden", coordinates: [18.6, 60.1], group: "Europe" },
    { key: "netherlands", coordinates: [5.3, 52.1], group: "Europe" },
    { key: "switzerland", coordinates: [8.2, 46.8], group: "Europe" },
    { key: "france", coordinates: [2.2, 46.2], group: "Europe" },
    { key: "north-macedonia", coordinates: [21.7, 41.6], group: "Europe" },
    { key: "belarus", coordinates: [27.9, 53.7], group: "CIS" },
    { key: "russia", coordinates: [90.0, 61.5], group: "CIS" },
    { key: "kazakhstan", coordinates: [66.9, 48.0], group: "CIS" },
    { key: "uae", coordinates: [54.4, 24.4], group: "Middle East & Africa" },
    { key: "saudi-arabia", coordinates: [45.1, 23.9], group: "Middle East & Africa" },
    { key: "egypt", coordinates: [30.8, 26.8], group: "Middle East & Africa" },
    { key: "senegal", coordinates: [-14.5, 14.5], group: "Middle East & Africa" },
    { key: "algeria", coordinates: [1.7, 28.0], group: "Middle East & Africa" },
    { key: "hong-kong", coordinates: [114.2, 22.3], group: "Asia" },
    { key: "vietnam", coordinates: [108.3, 14.1], group: "Asia" },
    { key: "cambodia", coordinates: [104.9, 12.6], group: "Asia" },
    { key: "india", coordinates: [78.9, 20.6], group: "Asia" },
    { key: "shenzhen", coordinates: [114.1, 22.5], group: "China (Home Market)" },
    { key: "suzhou", coordinates: [120.6, 31.3], group: "Asia" },
    { key: "united-states", coordinates: [-98.6, 39.8], group: "Americas" },
    { key: "argentina", coordinates: [-63.6, -38.4], group: "Americas" },
    { key: "brazil", coordinates: [-51.9, -14.2], group: "Americas" },
    { key: "guangzhou", coordinates: [113.3, 23.1], group: "China (Home Market)" },
  ],
};

export const translations = {
  en: {
    dir: "ltr",
    brand: "HI POWER ELECTRONICS",
    nav: ["Strengths", "Line Card", "Engineering", "Applications", "Contact"],
    contact: "Contact",
    modelFlow: ["Select", "Design-In", "Support Supply"],
    lineCard: {
      overline: "Authorized Line Card",
      title: "Authorized component lines, backed by application-level engineering.",
      description: "Hi Power represents five authorized principal lines. For customers, the value is not only sourcing — it is matching the right component to the application, supporting design-in discussion, and keeping supply aligned with production needs.",
      makesLabel: "Products",
      appsLabel: "Applications",
      partners: [
        { name: "TechPoint", native: "", category: "Automotive Imaging / ISP", makes: "Automotive video RX / TX, ISP, HD analog imaging", apps: "Vehicle cameras, ADAS, DVR / MDVR, CCTV imaging design-ins" },
        { name: "Phison", native: "", category: "Storage / SSD", makes: "SSD controllers, SSD and automotive-grade SSD", apps: "Automotive DVR, video storage, industrial and embedded storage" },
        { name: "ChipGoal", native: "奇高", category: "Power / Sensor IC", makes: "Power IC and ambient light sensor (ALS)", apps: "Camera modules, consumer electronics and automotive electronics" },
        { name: "Fitipower", native: "天钰", category: "Display / Power IC", makes: "Display driver IC and power-management IC", apps: "Displays, panels, embedded control and HMI systems" },
        { name: "Sitaiwei", native: "杭州思泰微", category: "Analog / Mixed-Signal", makes: "High-performance analog and mixed-signal IC", apps: "Signal chain, industrial electronics and automotive subsystems" },
      ],
    },
    hero: {
      overline: "Since 2009 · Shenzhen, China · Authorized Multi-Line Distributor",
      headline: "Engineering-Led Component Distribution for Camera, DVR, Automotive & Storage Systems",
      company: "HI POWER ELECTRONICS",
      subheadline: "Authorized supply, component selection, IQ tuning and design-in support for manufacturers.",
      description:
        "Hi Power (Shenzhen) Electronics helps end customers and manufacturers move from component sourcing to successful product design-in. We combine authorized trading for TechPoint, Phison, ChipGoal, Fitipower and Sitaiwei with engineering support in component selection, replacement suggestions and image-quality tuning for CCTV, automotive DVR, camera and SSD-related applications.",
      domains: ["Authorized Distribution", "IQ Tuning & Selection", "SSD Growth Focus"],
      panelLabels: ["Trusted Supply", "Engineering Support", "Storage Design-In"],
      ctas: ["Explore Applications", "Send Requirement"],
    },
    snapshot: {
      overline: "Company Snapshot",
      title: "Not only a component supplier — an engineering-capable distribution partner.",
      description:
        "Founded in 2009 in Shenzhen, Hi Power's foundation is authorized component trading. What makes us different is the engineering support around that supply: application matching, component selection, replacement recommendations and IQ tuning support for camera, DVR, automotive imaging and storage customers.",
      facts: [
        { label: "Founded", value: "2009" },
        { label: "Headquarters", value: "Shenzhen, China" },
        { label: "Customer Focus", value: "Auto · CCTV · DVR · SSD" },
        { label: "Authorized Lines", value: "TechPoint · Phison · ChipGoal · Fitipower · Sitaiwei" },
      ],
    },
    positioning: {
      overline: "Company Positioning",
      title: "Authorized distribution with design-in support — not just sourcing.",
      body:
        "Hi Power sits between authorized silicon and storage suppliers and the manufacturers who need to build reliable products. We help customers select suitable parts, evaluate alternatives, tune image quality and keep supply aligned through design-in and production.",
      cards: [
        ["Authorized Supply Foundation", "Authorized trading for TechPoint, Phison, ChipGoal (奇高), Fitipower (天钰) and Sitaiwei (杭州思泰微) across imaging, storage, power and analog / mixed-signal components."],
        ["Component Selection & Alternatives", "We help customer engineering teams compare devices, evaluate replacement options and select components that fit application, cost, supply and production requirements."],
        ["IQ Tuning & Imaging Know-How", "For camera, CCTV, DVR and automotive imaging projects, our engineers support image-quality tuning, sensor / chipset matching and practical design-in discussion."],
        ["SSD Growth Through Existing Channels", "We are extending existing camera and DVR relationships into Phison SSD and automotive-grade SSD opportunities for video and embedded storage."],
      ],
    },
    milestones: {
      overline: "Milestones",
      title: "A distribution business strengthened by real application engineering.",
      description: "Hi Power grew from Shenzhen chip trading into a multi-line authorized distributor with practical engineering support. The story is simple: reliable supply first, then deeper customer support through component selection, IQ tuning and design-in assistance.",
      items: [
        { year: "2009", title: "Shenzhen Chip Trading", text: "Established in Shenzhen as a chip-trading business, close to China's camera and electronics manufacturing base, building supplier access and customer channels." },
        { year: "Distribution", title: "Authorized Multi-Line Access", text: "Became an authorized distributor for TechPoint, Phison, ChipGoal, Fitipower and Sitaiwei — covering imaging, storage, power and analog / mixed-signal components." },
        { year: "Engineering", title: "Selection, Design-In & IQ", text: "Built engineering support around the trading business, including component selection, replacement suggestions and IQ / ISP tuning for automotive and CCTV applications." },
        { year: "Today", title: "Auto, CCTV and SSD Focus", text: "Serves camera, DVR and automotive manufacturers while expanding Phison SSD and automotive-grade SSD opportunities through existing customer channels." },
      ],
    },
    revenue: {
      overline: "Revenue Growth",
      title: "A growing, diversified business with a stronger 2026 outlook.",
      description: "Hi Power's revenue reflects steady growth across authorized chip distribution and engineering services, diversified over multiple supplier lines, with a stronger 2026 forecast as Phison SSD opportunities and automotive design-ins expand.",
      items: [
        { year: "2024", value: "US$5.8M", label: "Actual revenue" },
        { year: "2025", value: "US$6.3M", label: "Actual revenue" },
        { year: "2026", value: "US$8.0M", label: "Forecast revenue" },
      ],
    },
    operatingModel: {
      overline: "Engineering Support Process",
      title: "From requirement to design-in, we support the customer engineering team.",
      description: "Our role starts with authorized supply, but the customer value is in the engineering conversation around the part: what to choose, what to replace, how to validate it, and how to keep supply practical for production.",
      cards: [
        { title: "Understand the Application", text: "We start from the product requirement rather than only the part number.", items: ["Camera / CCTV architecture", "Automotive DVR environment", "SSD and video storage needs", "Cost, supply and lifecycle constraints"] },
        { title: "Recommend Components", text: "We help customer teams select suitable devices and evaluate replacement options.", items: ["TechPoint imaging selection", "Phison SSD / auto SSD fit", "Power, display and analog IC matching", "Alternative component suggestions"] },
        { title: "Support Design-In", text: "Our engineers help reduce trial-and-error during validation and ramp-up.", items: ["IQ / ISP tuning", "Sensor and chipset matching", "Debugging discussion", "Authorized supply follow-up"] },
      ],
    },
    capabilities: {
      overline: "Core Competencies",
      title: "Capabilities customers feel during real product development.",
      columns: [
        { title: "Supply Reliability", items: ["Authorized five-line access", "Local supply coordination", "Production follow-up", "Lifecycle awareness", "China customer coverage", "Principal communication"] },
        { title: "Engineering Selection", items: ["Component selection", "Replacement suggestions", "Sensor / chipset matching", "IQ / ISP tuning", "Camera / DVR design-in", "Validation discussion"] },
        { title: "Application Focus", items: ["Automotive camera", "CCTV surveillance", "DVR / MDVR systems", "Phison SSD attach", "Automotive-grade storage", "Embedded electronics"] },
      ],
      thesis: "Authorized supply becomes more valuable when it is connected to engineering judgment.",
    },
    cameraExpertise: {
      overline: "Camera & IQ Technical Expertise",
      title: "Hands-on know-how in automotive cameras, DVR systems, and image-quality tuning.",
      description: "Hi Power's credibility comes from authorized silicon access plus real engineering — tuning image quality for automotive cameras, dashcams, DVR systems, and CCTV in demanding conditions.",
      iq: { eyebrow: "Image Quality", title: "IQ tuning and ISP optimization", text: "We support image-quality tuning for night, tunnel, low-light, backlight, and vehicle vibration — leveraging our experience expanding TechPoint's ISP to reduce development trial-and-error." },
      activity: { number: "IQ", title: "Automotive camera support", text: "Ongoing IQ tuning and design-in activity across sensors, chipsets, and tier-1 automotive applications." },
    },
    solutions: {
      overline: "Business Domains",
      title: "Application focus: strong in Auto and CCTV, expanding into SSD.",
      domains: [
        {
          title: "Automotive Camera & DVR Solutions",
          eyebrow: "Imaging + storage for vehicles",
          description: "Automotive camera and DVR solutions built on TechPoint imaging silicon with in-house IQ tuning — with the option to pair Phison automotive-grade SSD storage.",
          items: ["Front / Rear Vehicle Cameras", "AI Dashcams", "MDVR Systems", "Phison Auto-Grade SSD Storage", "ISP / IQ Tuning", "Automotive-Grade Design"],
          products: ["TechPoint RX", "Automotive ISP", "Phison Auto SSD", "IQ Tuning"],
        },
        {
          title: "CCTV & DVR Surveillance",
          eyebrow: "Security and industrial imaging",
          description: "Professional CCTV and DVR imaging solutions for security and industrial applications.",
          items: ["IP Cameras", "Analog Cameras", "NVR / DVR Systems", "Image Quality Optimization", "OEM / ODM Support", "Technical Support"],
          products: ["CCTV Systems", "DVR / NVR", "IQ Optimization", "OEM Support"],
        },
        {
          title: "SSD & Embedded Storage",
          eyebrow: "Phison SSD growth focus",
          description: "Phison SSD and automotive-grade SSD are a strategic growth focus, especially where DVR, camera and automotive systems need reliable video and data storage.",
          items: ["Automotive-Grade SSD", "DVR / MDVR Storage", "Video Data Recording", "Industrial Embedded Storage", "Existing Camera Channels", "Design-In Discussion"],
          products: ["Phison SSD", "Auto-Grade SSD", "Video Storage", "Embedded Storage"],
        },
      ],
    },
    proof: {
      overline: "Project Proof Areas",
      title: "Where distribution plus engineering becomes visible.",
      description: "For end customers and manufacturers, the proof is practical: better component fit, faster design-in discussion, stronger IQ outcomes, and authorized supply that supports production.",
      stats: [
        { value: "~80%", label: "TechPoint RX market share" },
        { value: "5", label: "Authorized silicon lines" },
        { value: "Tier-1", label: "Automotive customers" },
      ],
      cards: [
        { title: "Automotive Camera Design-Ins", category: "Featured Program", featured: true, scope: ["TechPoint RX-based camera design", "Automotive-grade chipset selection", "ISP / IQ tuning", "Optional Phison auto-grade SSD"], outcome: "Helps tier-1 automotive camera manufacturers move from chipset selection to a tuned, manufacturable camera — with storage attach potential." },
        { title: "Phison SSD & Automotive-Grade SSD", category: "Growth Opportunity", scope: ["Phison SSD distribution", "Automotive-grade SSD", "Leverage existing DVR / camera channels", "Cross-sell to tier-1 clients"], outcome: "Drives Phison's SSD and automotive-grade SSD into our established automotive DVR and camera customer base — a clear new revenue lane." },
        { title: "IQ Tuning & ISP Expansion", category: "Engineering", scope: ["Night / tunnel / low-light tuning", "ISP parameter optimization", "Sensor and chipset matching", "Support for TechPoint ISP expansion"], outcome: "Reduces trial-and-error by aligning silicon, image quality, and real automotive conditions." },
        { title: "Multi-Line Authorized Distribution", category: "Distribution", scope: ["TechPoint, Phison, ChipGoal", "Fitipower, Sitaiwei lines", "Local stock and FAE support", "Supply continuity"], outcome: "Gives customers authorized access to imaging, storage, power and analog / mixed-signal silicon from a single, engineering-capable partner." },
        { title: "Product Coordination for Trinity", category: "Partnership", scope: ["Joint product design", "Manufacturing coordination", "Support for Trinity Group's Anchilex brand", "Global commercialization via Trinity"], outcome: "Hi Power coordinates and designs products that Trinity Electronic takes to global markets." },
      ],
    },
    global: {
      overline: "Coverage & Reach",
      title: "Shenzhen and Guangzhou focus, all-China territory, and global reach through Trinity.",
      regions: ["United Kingdom", "Italy", "Sweden", "The Netherlands", "Switzerland", "France", "North Macedonia", "Belarus", "Russia", "Kazakhstan", "United Arab Emirates", "Saudi Arabia", "Egypt", "Senegal", "Algeria", "Hong Kong", "Vietnam", "Cambodia", "India", "Shenzhen, China", "Suzhou, China", "United States", "Argentina", "Brazil", "Guangzhou, China"],
      stats: ["Founded 2009 in Shenzhen", "Focus: Shenzhen & Guangzhou · All-China Territory", "Global reach via Trinity strategic partnership"],
    },
    team: {
      overline: "Engineering & Business Team",
      title: "Engineering and FAE support close to the customer.",
      photo: "Profile Photo Placement",
      teams: [
        ["Imaging Engineering", "Senior IQ / ISP Engineers", ["IQ Tuning", "Chipset Design", "Sensor Matching"]],
        ["Automotive Solutions", "Automotive Camera & SSD Specialists", ["Tier-1 Support", "Auto-Grade Design", "Phison SSD Attach"]],
        ["Distribution & FAE", "Field Application Engineers", ["TechPoint · Phison", "ChipGoal · Fitipower", "Sitaiwei"]],
        ["Trinity Coordination", "Product Coordination Team", ["Joint Design", "Manufacturing", "Global Push"]],
      ],
    },
    partnership: {
      overline: "Partnership Opportunities",
      title: "Tell us your application. We will help evaluate the right component path.",
      description: "For camera, DVR, automotive imaging, CCTV or SSD-related projects, Hi Power can support authorized sourcing, component selection, replacement evaluation, IQ tuning discussion and design-in follow-up.",
      versions: [],
      buttons: ["Contact Us", "Schedule a Meeting"],
    },
    contactForm: {
      overline: "Inquiry Form",
      title: "Share your sourcing or design-in requirement.",
      description: "Tell us your application, product stage, target component line, technical requirement or supply need. Your message will be sent directly to info@hi-power-elec.com.",
      fields: { name: "Name", email: "Email", company: "Company", phone: "Phone", interest: "Area of Interest", message: "Message" },
      submitLabel: "Send Message",
      sendingLabel: "Sending…",
      successLabel: "Message sent. Thank you — Hi Power will follow up soon.",
      savedLabel: "Message received. Hi Power will follow up soon.",
      errorLabel: "Could not send message. Please try again.",
    },
    phison: {
      overline: "Phison Partnership — SSD & Automotive-Grade SSD",
      title: "Phison SSD is the next growth layer for DVR, camera and automotive customers.",
      description:
        "As an authorized Phison distributor, Hi Power is especially excited about Phison's SSD and automotive-grade SSD. We can leverage our existing automotive DVR and camera clients and channels to create natural, high-volume design-ins across China's automotive imaging segment.",
      points: [
        { title: "Automotive-Grade SSD Fit", text: "Automotive DVR and camera systems need reliable, automotive-grade storage — a direct fit for Phison's automotive-grade SSD within platforms we already support." },
        { title: "Ready-Made Channels", text: "We can drive Phison SSD into our established tier-1 automotive camera manufacturers and DVR customers in Shenzhen, Guangzhou, and across China — no channel build-up required." },
        { title: "Engineering-Led Design-Ins", text: "Our engineering team can bundle Phison storage with camera and DVR platforms and shorten the path from sample to mass production." },
      ],
      stats: ["Authorized Phison distributor", "SSD & automotive-grade SSD", "Existing DVR / camera channels", "Tier-1 automotive design-ins"],
    },
    footer: { company: "Hi Power (Shenzhen) Electronics Co., Ltd.", phone: "", email: "", address: "Shenzhen, Guangdong, China", copyright: "Copyright Hi Power (Shenzhen) Electronics · Strategic Partner of Trinity Electronic" },
  },
};

translations.zh = {
  dir: "ltr",
  brand: "成顶欣",
  nav: ["公司优势", "授权产品线", "工程支持", "应用领域", "联系我们"],
  contact: "联系我们",
  modelFlow: ["选型", "设计导入", "供货支持"],
  lineCard: {
    overline: "授权产品线",
    title: "授权原厂产品线，并以应用工程能力支撑客户导入。",
    description: "成顶欣代理五条授权原厂产品线。对客户而言，价值不只是采购与供货，而是帮助客户把合适的芯片选进产品、评估替代方案，并在设计导入与量产供货过程中持续支持。",
    makesLabel: "产品",
    appsLabel: "应用",
    partners: [
      { name: "科点 Techpoint", native: "", category: "车载影像 / ISP", makes: "车载视频 RX / TX、ISP、高清模拟影像", apps: "车载摄像头、ADAS、DVR / MDVR、CCTV 影像导入" },
      { name: "群联 Phison", native: "", category: "存储 / SSD", makes: "SSD 主控、SSD 与车规级 SSD", apps: "车载 DVR、视频存储、工业与嵌入式存储" },
      { name: "ChipGoal", native: "奇高", category: "电源 / 传感 IC", makes: "电源 IC、环境光传感器 (ALS)", apps: "摄像头模组、消费电子与汽车电子" },
      { name: "Fitipower", native: "天钰", category: "显示 / 电源 IC", makes: "显示驱动 IC、电源管理 IC", apps: "显示屏、面板、嵌入式控制与 HMI 系统" },
      { name: "Sitaiwei", native: "杭州思泰微", category: "模拟 / 混合信号", makes: "高性能模拟与混合信号 IC", apps: "信号链、工业电子与汽车子系统" },
    ],
  },
  hero: {
    overline: "始于 2009 · 中国深圳 · 多产品线授权代理",
    headline: "面向摄像头、DVR、车载与存储系统的工程型芯片分销伙伴",
    company: "成顶欣",
    subheadline: "授权供货、芯片选型、IQ 调校与设计导入支持。",
    description:
      "成顶欣（深圳）电子有限公司帮助终端客户与制造商，从芯片采购走向成功的产品设计导入。我们以 科点 Techpoint、群联 Phison、奇高 ChipGoal、天钰 Fitipower 与杭州思泰微的授权贸易为基础，同时提供芯片选型、替代建议、IQ 图像质量调校，以及面向 CCTV、车载 DVR、摄像头与 SSD 相关应用的工程支持。",
    domains: ["授权芯片分销", "IQ 调校与选型", "SSD 增长重点"],
    panelLabels: ["稳定供货", "工程支持", "存储导入"],
    ctas: ["查看应用", "提交需求"],
  },
  snapshot: {
    overline: "公司概览",
    title: "不只是芯片供应商，而是具备工程支持能力的分销伙伴。",
    description:
      "成顶欣（深圳）电子有限公司成立于 2009 年，基础能力是授权芯片贸易。真正形成差异化的，是围绕供货展开的工程支持：面向摄像头、DVR、车载影像与存储客户，提供应用匹配、芯片选型、替代建议与 IQ 调校支持。",
    facts: [
      { label: "成立时间", value: "2009 年" },
      { label: "总部", value: "中国深圳" },
      { label: "客户重点", value: "车载 · CCTV · DVR · SSD" },
      { label: "授权产品线", value: "科点 Techpoint · 群联 Phison · 奇高 · 天钰 · 思泰微" },
    ],
  },
  positioning: {
    overline: "公司定位",
    title: "以授权分销为基础，提供设计导入支持 —— 不只是采购。",
    body:
      "成顶欣连接授权芯片与存储原厂，以及需要打造可靠产品的制造客户。我们帮助客户选择合适器件、评估替代方案、调校图像质量，并在设计导入与量产供货过程中持续配合。",
    cards: [
      ["授权供货基础", "代理 科点 Techpoint、群联 Phison、奇高 ChipGoal、天钰 Fitipower 与杭州思泰微，覆盖影像、存储、电源及模拟 / 混合信号芯片。"],
      ["芯片选型与替代建议", "协助客户工程团队比较器件、评估替代方案，并结合应用、成本、供货与量产要求进行选择。"],
      ["IQ 调校与影像经验", "面向摄像头、CCTV、DVR 与车载影像项目，支持图像质量调校、传感器 / 芯片匹配与设计导入讨论。"],
      ["SSD 通过既有渠道增长", "将既有摄像头与 DVR 客户关系，延伸至 群联 Phison SSD 与车规级 SSD 的视频及嵌入式存储机会。"],
    ],
  },
  milestones: {
    overline: "发展历程",
    title: "由真正应用工程能力强化的分销业务。",
    description: "成顶欣 从深圳芯片贸易发展为多产品线授权代理，并在供货基础上形成实际工程支持。我们的路径很清晰：先做好可靠供货，再通过芯片选型、IQ 调校与设计导入支持，帮助客户把器件真正用进产品。",
    items: [
      { year: "2009", title: "深圳芯片贸易", text: "在深圳以芯片贸易起家，毗邻中国摄像头与电子制造基地，建立供应商资源与客户渠道。" },
      { year: "分销", title: "授权多产品线", text: "成为 科点 Techpoint、群联 Phison、奇高、天钰与杭州思泰微的授权代理 —— 覆盖影像、存储、电源及模拟 / 混合信号芯片。" },
      { year: "工程", title: "选型、导入与 IQ", text: "围绕贸易业务建立工程支持能力，包括芯片选型、替代建议，以及面向车载与 CCTV 应用的 IQ / ISP 调校。" },
      { year: "现今", title: "车载、CCTV 与 SSD 重点", text: "服务摄像头、DVR 与车载制造客户，同时通过既有客户渠道拓展 群联 Phison SSD 与车规级 SSD 机会。" },
    ],
  },
  revenue: {
    overline: "营收增长",
    title: "持续增长、产品线多元化的业务，2026 年展望更为强劲。",
    description: "成顶欣 的营收体现了授权芯片分销与工程服务的稳步增长，并通过多条供应商产品线实现多元化；随着 群联 Phison SSD 机遇与车载设计导入的扩大，2026 年预测更为强劲。",
    items: [
      { year: "2024", value: "US$5.8M", label: "实际营收" },
      { year: "2025", value: "US$6.3M", label: "实际营收" },
      { year: "2026", value: "US$8.0M", label: "营收预测" },
    ],
  },
  operatingModel: {
    overline: "工程支持流程",
    title: "从需求到设计导入，支持客户工程团队。",
    description: "我们的工作从授权供货开始，但客户真正需要的是围绕器件的工程判断：选什么、如何替代、如何验证，以及量产阶段如何保持供货配合。",
    cards: [
      { title: "理解应用需求", text: "我们从客户产品需求出发，而不只是处理料号。", items: ["摄像头 / CCTV 架构", "车载 DVR 使用环境", "SSD 与视频存储需求", "成本、供货与生命周期约束"] },
      { title: "推荐合适器件", text: "协助客户选择合适芯片，并评估可行替代方案。", items: ["科点 Techpoint 影像选型", "群联 Phison SSD / 车规 SSD 匹配", "电源、显示与模拟 IC 配套", "替代料建议"] },
      { title: "支持设计导入", text: "工程团队协助减少验证与导入阶段的试错。", items: ["IQ / ISP 调校", "传感器与芯片匹配", "调试讨论", "授权供货跟进"] },
    ],
  },
  capabilities: {
    overline: "核心能力",
    title: "客户在真实产品开发中感受到的能力。",
    columns: [
      { title: "供货可靠性", items: ["五条授权产品线", "本地供货协调", "量产跟进", "生命周期意识", "中国客户覆盖", "原厂沟通"] },
      { title: "工程选型", items: ["芯片选型", "替代料建议", "传感器 / 芯片匹配", "IQ / ISP 调校", "摄像 / DVR 导入", "验证讨论"] },
      { title: "应用重点", items: ["车载摄像头", "CCTV 安防", "DVR / MDVR 系统", "群联 Phison SSD 附加", "车规级存储", "嵌入式电子"] },
    ],
    thesis: "授权供货与工程判断连接在一起，才更有客户价值。",
  },
  cameraExpertise: {
    overline: "摄像与 IQ 技术专长",
    title: "在车载摄像头、DVR 系统与图像质量调校方面的实战经验。",
    description: "成顶欣 的可信度源于授权芯片资源与真正的工程能力 —— 在严苛环境下为车载摄像头、行车记录仪、DVR 系统与 CCTV 进行图像质量调校。",
    iq: { eyebrow: "图像质量", title: "IQ 调校与 ISP 优化", text: "我们支持针对夜间、隧道、弱光、逆光及车辆振动的图像质量调校 —— 借助拓展 科点 Techpoint ISP 的经验，减少开发中的试错。" },
    activity: { number: "IQ", title: "车载摄像头支持", text: "在不同传感器、芯片与一线车载应用中持续开展 IQ 调校与设计导入工作。" },
  },
  solutions: {
    overline: "业务领域",
    title: "应用重点：强项在车载与 CCTV，并逐步强化 SSD。",
    domains: [
      { title: "车载摄像与 DVR 方案", eyebrow: "面向车辆的影像 + 存储", description: "基于 科点 Techpoint 影像芯片、配合自有 IQ 调校的车载摄像头与 DVR 方案 —— 并可选配 群联 Phison 车规级 SSD 存储。", items: ["前 / 后车载摄像头", "AI 行车记录仪", "MDVR 系统", "群联 Phison 车规级 SSD 存储", "ISP / IQ 调校", "车规级设计"], products: ["科点 Techpoint RX", "车载 ISP", "群联 Phison 车规 SSD", "IQ 调校"] },
      { title: "CCTV 与 DVR 安防", eyebrow: "安防与工业影像", description: "面向安防与工业应用的专业 CCTV 与 DVR 影像方案。", items: ["IP 摄像头", "模拟摄像头", "NVR / DVR 系统", "图像质量优化", "OEM / ODM 支持", "技术支持"], products: ["CCTV 系统", "DVR / NVR", "IQ 优化", "OEM 支持"] },
      { title: "SSD 与嵌入式存储", eyebrow: "群联 Phison SSD 增长重点", description: "群联 Phison SSD 与车规级 SSD 是成顶欣下一阶段重点，尤其适用于 DVR、摄像头与车载系统中的视频和数据存储需求。", items: ["车规级 SSD", "DVR / MDVR 存储", "视频数据记录", "工业嵌入式存储", "既有摄像头客户渠道", "设计导入讨论"], products: ["群联 Phison SSD", "车规级 SSD", "视频存储", "嵌入式存储"] },
    ],
  },
  proof: {
    overline: "项目实证领域",
    title: "分销能力与工程能力结合后，价值才真正可见。",
    description: "对终端客户和制造商而言，实证来自实际项目过程：器件更匹配、设计导入讨论更快、IQ 效果更稳定，并且授权供货能够支撑量产。",
    stats: [
      { value: "约 80%", label: "科点 Techpoint RX 市场份额" },
      { value: "5", label: "授权芯片产品线" },
      { value: "一线", label: "车载客户" },
    ],
    cards: [
      { title: "车载摄像头设计导入", category: "重点项目", featured: true, scope: ["基于 科点 Techpoint RX 的摄像头设计", "车规级芯片选型", "ISP / IQ 调校", "可选 群联 Phison 车规级 SSD"], outcome: "帮助一线车载摄像头制造商从芯片选型走向经过调校、可量产的摄像头方案 —— 并具备存储附加销售潜力。" },
      { title: "群联 Phison SSD 与车规级 SSD", category: "增长机遇", scope: ["群联 Phison SSD 分销", "车规级 SSD", "利用既有 DVR / 摄像头渠道", "向一线客户交叉销售"], outcome: "将 群联 Phison 的 SSD 与车规级 SSD 导入我们既有的车载 DVR 与摄像头客户群 —— 一条清晰的新营收线。" },
      { title: "IQ 调校与 ISP 拓展", category: "工程", scope: ["夜间 / 隧道 / 弱光调校", "ISP 参数优化", "传感器与芯片匹配", "支持 科点 Techpoint ISP 拓展"], outcome: "通过对齐芯片、图像质量与真实车载环境，减少开发试错。" },
      { title: "多产品线授权分销", category: "分销", scope: ["科点 Techpoint、群联 Phison、奇高", "天钰、思泰微产品线", "本地库存与 FAE 支持", "供货连续性"], outcome: "让客户从一家具备工程能力的合作伙伴，获得影像、存储、电源及模拟 / 混合信号芯片的授权资源。" },
      { title: "为 Trinity Electronics 协调产品", category: "合作", scope: ["联合产品设计", "制造协调", "支持 Trinity Electronics 集团 Anchilex 品牌", "通过 Trinity Electronics 全球商业化"], outcome: "成顶欣 协调并设计产品，由 Trinity Electronics 推向全球市场。" },
    ],
  },
  global: {
    overline: "覆盖与触达",
    title: "聚焦深圳与广州，覆盖全中国，并通过 Trinity Electronics 触达全球。",
    regions: ["英国", "意大利", "瑞典", "荷兰", "瑞士", "法国", "北马其顿", "白俄罗斯", "俄罗斯", "哈萨克斯坦", "阿联酋", "沙特阿拉伯", "埃及", "塞内加尔", "阿尔及利亚", "香港", "越南", "柬埔寨", "印度", "中国深圳", "中国苏州", "美国", "阿根廷", "巴西", "中国广州"],
    stats: ["2009 年成立于深圳", "聚焦：深圳与广州 · 覆盖全中国", "通过 Trinity Electronics 战略合作触达全球"],
  },
  team: {
    overline: "工程与业务团队",
    title: "贴近客户的工程与 FAE 支持。",
    photo: "头像照片位置",
    teams: [
      ["影像工程", "资深 IQ / ISP 工程师", ["IQ 调校", "芯片设计", "传感器匹配"]],
      ["车载方案", "车载摄像头与 SSD 专家", ["一线客户支持", "车规级设计", "群联 Phison SSD 附加"]],
      ["分销与 FAE", "现场应用工程师", ["科点 Techpoint · 群联 Phison", "奇高 · 天钰", "思泰微"]],
      ["Trinity Electronics 协调", "产品协调团队", ["联合设计", "制造协调", "推向全球"]],
    ],
  },
  partnership: {
    overline: "合作机会",
    title: "告诉我们您的应用需求，我们协助评估合适的器件路径。",
    description: "面向摄像头、DVR、车载影像、CCTV 或 SSD 相关项目，成顶欣 可支持授权采购、芯片选型、替代评估、IQ 调校讨论与设计导入跟进。",
    versions: [],
    buttons: ["联系我们", "预约会议"],
  },
    contactForm: {
      overline: "留言表单",
      title: "提交您的采购或设计导入需求。",
      description: "请告诉我们您的应用领域、产品阶段、关注产品线、技术要求或供货需求。留言将直接发送至 info@hi-power-elec.com。",
      fields: { name: "姓名", email: "邮箱", company: "公司", phone: "电话", interest: "关注领域", message: "留言内容" },
      submitLabel: "发送留言",
      sendingLabel: "发送中…",
      successLabel: "留言已发送，谢谢您。成顶欣 将尽快跟进。",
      savedLabel: "留言已收到。成顶欣 将尽快跟进。",
      errorLabel: "暂时无法发送留言，请稍后再试。",
    },
  phison: {
    overline: "群联 Phison 合作 —— SSD 与车规级 SSD",
    title: "群联 Phison SSD 是面向 DVR、摄像头与车载客户的下一层增长。",
    description:
      "作为 群联 Phison 的授权代理，成顶欣 对 群联 Phison 的 SSD 与车规级 SSD 尤为期待。我们能够利用既有的车载 DVR 与摄像头客户及渠道，在中国车载影像领域创造自然、规模化的设计导入机会。",
    points: [
      { title: "车规级 SSD 的契合", text: "车载 DVR 与摄像系统需要可靠的车规级存储 —— 这正与 群联 Phison 的车规级 SSD 在我们已支持的平台中直接契合。" },
      { title: "现成渠道", text: "我们可将 群联 Phison SSD 导入深圳、广州及全中国既有的一线车载摄像头制造商与 DVR 客户 —— 无需重新搭建渠道。" },
      { title: "以工程驱动的设计导入", text: "我们的工程团队可将 群联 Phison 存储与摄像头及 DVR 平台捆绑，缩短从样品到量产的路径。" },
    ],
    stats: ["群联 Phison 授权代理", "SSD 与车规级 SSD", "既有 DVR / 摄像头渠道", "一线车载设计导入"],
  },
  footer: { company: "成顶欣（深圳）电子有限公司", phone: "", email: "", address: "中国广东省深圳市", copyright: "版权所有 成顶欣（深圳）电子有限公司 · Trinity Electronics 战略合作伙伴" },
};


export const getLocalizedContent = (languageCode) => {
  const base = translations[languageCode] || translations.en;
  return {
    ...base,
    heroPanels: common.heroPanels.map((panel, index) => ({
      ...panel,
      title: base.hero.domains[index],
      label: base.hero.panelLabels[index],
    })),
    snapshotImages: common.snapshotImages,
    lineCardImages: common.lineCardImages,
    milestoneImages: common.milestoneImages,
    phisonImages: common.phisonImages,
    capabilityImages: common.capabilityImages,
    globalImages: common.globalImages,
    partnershipImages: common.partnershipImages,
    mapRegions: common.mapRegions.map((region, index) => ({
      ...region,
      name: base.global.regions[index],
    })),
  };
};

const pickActiveTranslations = (source = {}) => Object.fromEntries(
  languages.map(({ code }) => [code, source[code] || translations[code] || translations.en])
);

export const getEditableSeedContent = () => ({
  version: CONTENT_VERSION,
  common,
  translations: pickActiveTranslations(translations),
});

const isPlainObject = (value) => value && typeof value === "object" && !Array.isArray(value);

const deepMerge = (base, override) => {
  if (!isPlainObject(base) || !isPlainObject(override)) return override === undefined ? base : override;
  return Object.keys({ ...base, ...override }).reduce((merged, key) => {
    merged[key] = deepMerge(base[key], override[key]);
    return merged;
  }, {});
};

const mergeSectionOrder = (existingOrder = []) => {
  const validExisting = existingOrder.filter((sectionKey) => common.sectionOrder.includes(sectionKey));
  return common.sectionOrder.reduce((mergedOrder, sectionKey) => {
    if (mergedOrder.includes(sectionKey)) return mergedOrder;
    const defaultIndex = common.sectionOrder.indexOf(sectionKey);
    const nextExistingIndex = common.sectionOrder.slice(defaultIndex + 1).reduce((foundIndex, nextSectionKey) => {
      if (foundIndex !== -1) return foundIndex;
      return mergedOrder.indexOf(nextSectionKey);
    }, -1);
    const insertAt = nextExistingIndex === -1 ? mergedOrder.length : nextExistingIndex;
    mergedOrder.splice(insertAt, 0, sectionKey);
    return mergedOrder;
  }, [...validExisting]);
};

export const normalizeEditableContent = (editableContent) => {
  const normalized = deepMerge(getEditableSeedContent(), editableContent || {});
  normalized.version = CONTENT_VERSION;
  normalized.translations = pickActiveTranslations(normalized.translations || translations);
  normalized.common.sectionOrder = mergeSectionOrder(normalized.common.sectionOrder || []);
  normalized.common.hiddenSections = normalized.common.hiddenSections || [];
  normalized.common.mapRegions = common.mapRegions.map((region) => {
    const savedRegion = (normalized.common.mapRegions || []).find((item) => item.key === region.key);
    return { ...region, ...savedRegion, coordinates: savedRegion?.coordinates || region.coordinates, group: savedRegion?.group || region.group };
  });
  return normalized;
};

export const getLocalizedContentFromEditable = (languageCode, editableContent) => {
  const source = editableContent?.translations ? normalizeEditableContent(editableContent) : getEditableSeedContent();
  const base = source.translations?.[languageCode] || translations[languageCode] || translations.en;
  const shared = source.common || common;
  const defaultRegionsByKey = Object.fromEntries(common.mapRegions.map((region) => [region.key, region]));
  return {
    ...base,
    heroPanels: (shared.heroPanels || common.heroPanels).map((panel, index) => ({
      ...panel,
      title: base.hero.domains[index],
      label: base.hero.panelLabels[index],
    })),
    proofImages: shared.proofImages || common.proofImages,
    snapshotImages: shared.snapshotImages || common.snapshotImages,
    lineCardImages: shared.lineCardImages || common.lineCardImages,
    milestoneImages: shared.milestoneImages || common.milestoneImages,
    phisonImages: shared.phisonImages || common.phisonImages,
    capabilityImages: shared.capabilityImages || common.capabilityImages,
    globalImages: shared.globalImages || common.globalImages,
    partnershipImages: shared.partnershipImages || common.partnershipImages,
    partnerLogos: shared.partnerLogos || common.partnerLogos,
    solutionImages: shared.solutionImages || common.solutionImages,
    brandLogo: shared.brandLogo || common.brandLogo,
    teamImages: shared.teamImages || common.teamImages,
    sectionOrder: shared.sectionOrder || common.sectionOrder,
    hiddenSections: shared.hiddenSections || [],
    mapRegions: (shared.mapRegions || common.mapRegions).map((region, index) => ({
      ...defaultRegionsByKey[region.key],
      ...region,
      coordinates: region.coordinates || defaultRegionsByKey[region.key]?.coordinates || [0, 0],
      group: region.group || defaultRegionsByKey[region.key]?.group || "Other",
      name: base.global.regions[index] || region.key,
    })),
  };
};
